export default (state = "green", action) => {
  switch (action.type) {
    case "painter/paint":
      return state == "green" ? "red" : "green";
    default:
      return state;
  }
};
